module.exports = __webpack_public_path__ + "static/media/academy.90199c5f.jpg";